import { Component } from '@angular/core';
import { OrderDetailTotalsComponent, OrderDetailsService } from '@spartacus/order/components';
import { CustomOrderDetailsService } from '../custom-order-details.service';

@Component({
  selector: 'cx-order-details-totals',
  templateUrl: './custom-order-detail-totals.component.html',
  standalone: false
})
export class CustomOrderDetailTotalsComponent extends OrderDetailTotalsComponent {

  constructor(
    protected orderDetailsService: OrderDetailsService,
    protected customOrderDetailsService: CustomOrderDetailsService,
  ) {
    super(orderDetailsService);
  }

}
